import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import orderStatusCardMapper from './OrderStatusCardMapper';

export default function StatusCard() {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    rcbPurchasing: { hasError }
  } = useContext(UserVehicleContext);

  if (hasError) {
    trackEvent('Order Status Card Load Failed');

    return null;
  }

  return <div>{orderStatusCardMapper()}</div>;
}
